var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3KnxProtocol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.77 48h-5.34l-4.75-5.67-5.5 5.67h-4.49l7.93-8.07-6.31-7.52h5.25L58.49 37l4.58-4.6h4.49l-7 7 7.21 8.6zM40.7 42.17l-6.94-9.78H28.3V48h4.51v-9.69L40 48h5.16V32.41h-4.48l.02 9.76zm-2.38-19a40.81 40.81 0 0124.73 8.28h4.49a44.13 44.13 0 00-58.63 0h4.49a41.2 41.2 0 0124.92-8.25v-.03zM18 38.84l6.36-6.45h-4.48L13.4 39v-6.59H8.93L8.91 48h4.49v-4.44l1.78-1.8L20.43 48h5.35l-7.08-8.37-.7-.79z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_KNX_protocol.dd5672d6.svg";
export { SvgJ3KnxProtocol as ReactComponent };